// extracted by mini-css-extract-plugin
export default {"billTable":"kisan-bill_billTable__zA9ng","errMsg":"kisan-bill_errMsg__uGjmV"};